import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import { Chip, SvgLock2Bold } from '@insights-ltd/design-library/components';

const StyledLock = styled(SvgLock2Bold)(() => ({
  fill: 'currentColor',
  transform: 'scale(67%)',
}));

export const SpecialHandlingChip = () => {
  const { t } = useTranslation();
  return (
    <Chip
      icon={<StyledLock />}
      label={t('ui.event-management.special-handling.tag')}
      color="grey"
    />
  );
};
